import { LanguageProvider as LanguageProviderBase } from '@spazious/dollhouse-i18n';
import * as locales from '@spazious/dollhouse-locales';
import { useStore } from '@spazious/dollhouse-store';

export interface LanguageProviderProps {
  children: React.ReactNode;
}

/**
 * Custom LanguageProvider component that uses the default language from the store
 */
export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const defaultLanguage = useStore(({ language }) => language);

  return (
    <LanguageProviderBase defaultLocale={defaultLanguage} locales={locales}>
      {children}
    </LanguageProviderBase>
  );
};
